import { type AxiosResponse } from 'axios';

import { get, post, put } from '@utilities';

export const fetchHolidays = async (): Promise<AxiosResponse> => await get('calendar/all');
export const addHolidays = async (data: Record<string, any>): Promise<AxiosResponse> => await post('calendar', data);
export const deleteHolidays = async (date: any): Promise<AxiosResponse> => await put(`calendar/remove?epoch=${date}`);
export const updateHolidays = async (data: Record<string, any>): Promise<AxiosResponse> => await put('calendar', data);
